module.exports = __webpack_public_path__ + "static/media/wristband-empty.b93165bb.png";